<template></template>


<script>
  import { STORE_PREFIX } from './constants.js';
  import store from './stores.js';

  export default {
    name: 'relogin',

    mixins: [store],

    computed: {
      user_admin_data() {
        return this.$store.getters['user/accessToken']
      },

      user_email() {
        if (!this.$route || !this.$route.query) {
          return '';
        }

        return this.$route.query.user_email
      },

      to() {
        if (!this.$route || !this.$route.query || this.$route.query.to === 'relogin') {
          return 'vacancies';
        }

        return this.$route.query.to || 'vacancies'
      }
    },

    methods: {
      redirect_to_home() {
        this.$router.push({to: ''})
      }
    },

    mounted() {
      if (!this.$route.query.user_email) {
        this.redirect_to_home();
        return;
      }
      if (!this.user_email || !this.user_admin_data) {
        this.redirect_to_home()
      }

      if (this.user_email) {
        this.$store.dispatch(STORE_PREFIX + 'admin/authUser', {
          email: this.user_email
        })
        .then(() => {
          this.$router.push({path: this.to})
        })
      } else {
        this.$router.push({path: this.to})
      }
    }
  }
</script>